var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01367 1.10547C5.36523 0.724609 5.98047 0.724609 6.33203 1.10547L10.082 4.85547C10.3457 5.11914 10.4336 5.5293 10.2871 5.88086C10.1406 6.23242 9.81836 6.4668 9.4375 6.4668H1.9375C1.55664 6.4668 1.20508 6.23242 1.05859 5.88086C0.912109 5.5293 1 5.11914 1.26367 4.85547L5.01367 1.10547ZM5.01367 13.6738L1.26367 9.92383C1 9.66016 0.912109 9.25 1.05859 8.89844C1.20508 8.54688 1.55664 8.3125 1.9375 8.3125H9.4375C9.78906 8.3125 10.1406 8.54688 10.2871 8.89844C10.4336 9.25 10.3457 9.66016 10.082 9.92383L6.33203 13.6738C5.98047 14.0547 5.36523 14.0547 5.01367 13.6738Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.b25a6d3f5a86b3d75abef39c2e1ee54d.svg";
export { ForwardRef as ReactComponent };